import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { Navbar, Nav, NavItem, Alert, NavDropdown, MenuItem } from "react-bootstrap";
import Routes from "./Routes";
import { authUser, getUserAttributes } from "./libs/awsLib";
import MetisMenu from 'react-metismenu';
import RouterLink from 'react-metismenu-router-link';
/*import { Offline } from "react-detect-offline";*/
import config from './config';
import ReactGA from 'react-ga'

import "./App.css";
import "./menu.css"

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      showAlertError: false,
      alertMessage: '',
      profile: null,
      fullname: '',
      expanded: false,
      openFleetMenu: false
    };
  }

  async componentDidMount() {
    ReactGA.pageview(window.location.pathname);
    try {
      if (await authUser()) {
        this.userHasAuthenticated(true);
      }
    } catch(e) {
      console.log(JSON.stringify(e));
      //this.handleAlertError('Usuario no autenticado');
    }
    this.setState({ isAuthenticating: false });
  }

  async componentDidUpdate() {
    const user = await getUserAttributes();
    if (user.profile !== this.state.profile) {
      this.setState({ profile: user.profile });
    }
  }

  userHasAuthenticated = (authenticated, fullname) => {
    this.setState({ isAuthenticated: authenticated, fullname: fullname });
  }

  onToggle = (event) => {
  	this.setState({ expanded: !this.state.expanded });
  }

  onSelect = (event) => {
    this.setState({ expanded: false });
  }

  onSelectMenu = (event) => {
	this.setState({ expanded: false, openFleetMenu: false });
  }

  onToggleFleetMenu = (evet) => {
	  this.setState({ openFleetMenu: !this.state.openFleetMenu });
  }

  handleAlertError = (message) => {
    this.setState({ alertMessage: message, showAlertError: true });
  }

  handleDismissError = () => {
	  this.setState({ showAlertError: false });
  }

  renderPrivate(childProps) {
    const menuContent = [
      {
          icon: 'dashboard',
            label: 'Resumen',
            to: '/',
            title: 'Resumen'
        },
        {
            icon: 'map',
            label: 'Mapa',
            to: '/map',
        },
        {
            icon: 'bell',
            label: 'Gestión de Alertas',
            to: '/alert',
        },
        {
            icon: 'caret-right',
            label: 'Viajes',
            to: '/trips',
        },
        {
          icon: 'book',
            label: 'Reportes',
            to: '/report'
        },
        {
            icon: 'cogs',
            label: 'Configuración',
            content: [
                {
                    icon: 'car',
                    label: 'Vehículos',
                    to: '/unit',
                },
                {
                  icon: 'bell',
                    label: 'Alertas',
                    to: '/alert',
                },
                {
                  icon: 'map-marker',
                    label: 'Geozonas',
                    to: '/gefence',
                },
                {
                    icon: 'user',
                    label: 'Personas',
                    to: '/person',
                },
                {
                  icon: 'usd',
                  label: 'Clientes',
                  to: '/customer',
                }
            ],
        }

    ];
    return (
      <div className="row">
          <Navbar onToggle={this.onToggle} onSelect={this.onSelect} expanded={this.state.expanded}>
	        <Navbar.Header>
	          <Navbar.Header>
	            <Navbar.Brand>
                <Link to="/">
                  Fleet App
                </Link>
              </Navbar.Brand>
	            <Navbar.Toggle />
		      </Navbar.Header>
	        </Navbar.Header>
	        <Navbar.Collapse>
	          <Nav>
	          	<NavDropdown eventKey={1} title="Flota" id="dropdown-fleet" onToggle={this.onToggleFleetMenu} open={this.state.openFleetMenu}>
	          	  <MetisMenu ref="menu" content={menuContent} LinkComponent={RouterLink} onSelected={this.onSelectMenu} />
	          	</NavDropdown>
	          </Nav>
            <Nav pullRight>
              <NavItem eventKey={1} href={config.login_url}>
                Administraci&oacute;n
              </NavItem>
          	</Nav>
	        </Navbar.Collapse>
	      </Navbar>
	        <Routes childProps={childProps} />
	    </div>
    );
  }

  renderPublic(childProps) {
    return (
      <div className="row">
          <Routes childProps={childProps} />
  		</div>
    );
  }

  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated
    };
    return (
      !this.state.isAuthenticating &&
      <div className="App container">
  	    {
  	      this.state.isAuthenticated ? this.renderPrivate(childProps) : this.renderPublic(childProps)
  	    }
        <footer className="navbar-default">
          <div className="nav-footer">
            <a href={config.terms} target="_blank">Términos y condiciones</a>
            <a href={config.policy} target="_blank">Política de privacidad</a>
            <center className="copyright">
              © App desarrollada por <Navbar.Link href="http://www.neokode.cl" target="_blank">Neokode</Navbar.Link>
            </center>
          </div>
        </footer>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js